module.exports = __webpack_public_path__ + "static/media/eco-friendly.472ba8ae.png";